import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconVoiceSelector = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1114 7.47086C13.6883 4.19643 10.8896 1.66675 7.49998 1.66675C3.81808 1.66675 0.833313 4.65151 0.833313 8.33341C0.833313 9.91041 1.38087 11.3595 2.29623 12.501C2.96957 13.3407 3.33359 14.2711 3.33352 15.2552L3.33331 18.3334H10.8333L10.8341 15.8334H12.5C13.4205 15.8334 14.1666 15.0872 14.1666 14.1667V11.7259L15.7994 11.0265C16.0854 10.904 16.1103 10.614 15.9868 10.4198L14.1114 7.47086ZM2.49998 8.33341C2.49998 5.57199 4.73855 3.33341 7.49998 3.33341C10.0202 3.33341 12.1387 5.20959 12.4584 7.6844L12.506 8.05226L13.7914 10.0735L12.5 10.6267V14.1667H9.16806L9.16723 16.6667H5.00009L5.00019 15.2553C5.00028 13.8894 4.50802 12.5951 3.59646 11.4583C2.89013 10.5775 2.49998 9.4875 2.49998 8.33341ZM17.6279 15.0854L16.2411 14.1608C17.0363 12.9702 17.5 11.5393 17.5 10.0002C17.5 8.46091 17.0363 7.03 16.2411 5.83943L17.6279 4.91484C18.6 6.36996 19.1666 8.11886 19.1666 10.0002C19.1666 11.8814 18.6 13.6302 17.6279 15.0854Z",
		fill: "currentColor"
	})
});
export default SvgIconVoiceSelector;
